import styled from '@emotion/styled'
import { Link } from 'gatsby'
import React from 'react'
import { Helmet } from 'react-helmet'
import BreakPoints from '../../styles/breakPoints'
import useRouteParam from '../../hooks/useRouteParam'

const Wrapper = styled.header`
  display: flex;
  align-items: center;
  padding: 0 10px;
  height: 80px;
  width: 100vw;
  justify-content: space-between;
  position: fixed;
  background: #ffffff;
  z-index: 2;

  .logo-wrap {
    margin: 0 auto 0 0;

    .p-header-logo {
      width: 250px;
      height: auto;
      display: flex;
      align-items: center;

      img {
        width: 100%;
      }
    }

    h1 {
      font-weight: 400;
      font-size: 11.5px;
      margin: 6px 0 0 6px;
      color: #153758;
    }
  }

  .right-area {
    padding: 0 20px 0 0;
    display: flex;
    align-items: center;

    .search-input-wrap {
      margin-right: 20px;
    }

    .download-link {
      margin-left: 20px;
    }

    .product-link {
      display: none;
    }
  }

  ${BreakPoints.large} {
    .right-area {
      .product-link {
        display: block;
        margin-left: 20px;
      }
    }
  }

  ${BreakPoints.medium} {
    .logo-wrap {
      margin: 0 auto 0 0;

      .p-header-logo {
        width: 160px;
      }

      h1 {
        display: none;
      }
    }

    .right-area {
      padding: 0;

      .support-link,
      .product-link {
        display: none;
      }
    }
  }

  ${BreakPoints.small} {
  }
`

type Props = {
  /** クラス名 */
  className?: string
}

/**
 * コラムヘッダーコンポーネント
 * @constructor
 */
const ColumnHeader = (props: Props): JSX.Element => {
  const { className = '' } = props
  const routeParam = useRouteParam('/contact/')
  const routeParam2 = useRouteParam('/download/')
  const routeParam3 = useRouteParam('/support/')

  return (
    <>
      <Helmet>
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2094251769663608"
          crossOrigin="anonymous"
        />
      </Helmet>
      <Wrapper className={className}>
        <div className="logo-wrap">
          <Link to={useRouteParam('/column/')} className="p-header-logo">
            <img src="/images/column/top/logo.png" alt="キンクラコラム" />
          </Link>
          <h1>
            勤怠管理、労働基準法に関する知識や役に立つ情報をお届けするキンクラコラム
          </h1>
        </div>
        <div className="right-area">
          <a
            className="support-link"
            href={routeParam}
            target="_blank"
            rel="noreferrer"
          >
            お問い合わせ
          </a>
          <a
            className="download-link"
            href={routeParam2}
            target="_blank"
            rel="noreferrer"
          >
            資料ダウンロード
          </a>
          <a
            className="product-link"
            href={routeParam3}
            target="_blank"
            rel="noreferrer"
          >
            製品情報
          </a>
        </div>
      </Wrapper>
    </>
  )
}

export default ColumnHeader
